// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const dovecotePigeon = defineModel({
  id: "dovecote-pigeon",
  batchId: "future",
  name: "Dovecote pigeon",
  tags: ["creature","dovecote","pigeon","low-poly","age-of-mcp","future"],
  summary: "Dovecote pigeons — meat, carried messages and rich guano fertiliser.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.06,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.0035, 0.0028, 0.026, 4), color: "#c54a3a", position: [0.004, 0.013, 0.012] },
      { geometry: new THREE.CylinderGeometry(0.0035, 0.0028, 0.026, 4), color: "#c54a3a", position: [0.004, 0.013, -0.012] },
      { geometry: new THREE.IcosahedronGeometry(0.036, 0), color: "#9aa0aa", position: [0, 0.058, 0], scale: [1.35, 1.05, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.02, 0), color: "#b8a0b0", position: [0.03, 0.072, 0], scale: [1, 1.1, 1] },
      { geometry: new THREE.CylinderGeometry(0.04, 0.04, 0.006, 10, 1, false, 0, 3.141593), color: "#aab0ba", position: [-0.045, 0.07, 0], rotation: [-0.3, 1.570796, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.016, 0), color: "#aab0ba", position: [0.044, 0.088, 0] },
      { geometry: new THREE.ConeGeometry(0.005, 0.013, 4), color: "#5a5560", position: [0.058, 0.086, 0], rotation: [0, 0, -1.5] },
      { geometry: new THREE.IcosahedronGeometry(0.0028, 0), color: "#181410", position: [0.05, 0.092, 0.01] },
      { geometry: new THREE.IcosahedronGeometry(0.0028, 0), color: "#181410", position: [0.05, 0.092, -0.01] },
    ],
  animations: [],
});
